<template>
  <div class="title padd-v-3">
    {{ textSearch }}
    <span>{{ filter }}</span>
    <slot></slot>
  </div>
</template>

<script>
import { createFreeSearchBookListStore } from "@/store_pinia";

export default {
  props: ["searchId"],
  computed: {
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    getFreeSearchBookListStore() {
      return this.freeSearchBookListStore || {};
    },
    getTextSearch() {
      return this.getFreeSearchBookListStore.textSearch;
    },
    getFinalTextSearch() {
      return this.getFreeSearchBookListStore.finalTextSearch;
    },
    getCurrentFilterName() {
      return this.getFreeSearchBookListStore.getCurrentFilterName;
    },
    getFSListName() {
      return this.getFreeSearchBookListStore.currentFsSavedList;
    },
    textSearch() {
      return this.getFSListName != ""
        ? this.getFSListName
        : this.getFinalTextSearch && this.getFinalTextSearch.length > 0
        ? this.getFinalTextSearch
        : this.$t("quickBtn.noBookInList");
    },
    filter() {
      let filterTitle = this.getCurrentFilterName;
      if (filterTitle != "") filterTitle = " / " + filterTitle;
      return " " + filterTitle;
    },
  },
};
</script>

<style lang="scss" scoped></style>
